import {
  makeDataState,
  makePaginationState,
  makeListState,
  STATUSES,
} from 'app/utils/redux';

import { SECTION_TYPES } from 'app/utils/constants';

import * as t from './types';


const initialState = {
  sectionType: null,
  curations: makeDataState(),
  banners: makeListState(),
  sections: makeListState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    // fetch curations
    case `${t.FETCH_CURATIONS}_PENDING`:
      return {
        ...state,
        curations: {
          ...state.curations,
          status: STATUSES.PENDING,
          isLoaded: false,
        },
      };

    case `${t.FETCH_CURATIONS}_SUCCESS`:
      return {
        ...state,
        curations: {
          sectionType: action.meta.type,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          data: action.payload.result,
        },
      };

    case `${t.FETCH_CURATIONS}_ERROR`:
      return {
        ...state,
        curations: {
          ...state.curations,
          status: STATUSES.ERROR,
        },
      };

    // fetch curations
    case `${t.FETCH_CURATIONS_BANNERS}_PENDING`:
      return {
        ...state,
        banners: {
          ...state.banners,
          status: STATUSES.PENDING,
          isLoaded: false,
        },
      };

    case `${t.FETCH_CURATIONS_BANNERS}_SUCCESS`:
      return {
        ...state,
        banners: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          list: action.payload.result,
        },
      };

    case `${t.FETCH_CURATIONS_BANNERS}_ERROR`:
      return {
        ...state,
        banners: {
          ...state.curations,
          status: STATUSES.ERROR,
        },
      };

    // fetch stories
    case `${t.FETCH_STORIES}_PENDING`:
      return {
        ...state,
        [`section-${action.meta.sectionId}`]: {
          ...state[`section-${action.meta.sectionId}`],
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_STORIES}_SUCCESS`:
      return {
        ...state,
        [`section-${action.meta.sectionId}`]: {
          ...state[`section-${action.meta.sectionId}`],
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: state[`section-${action.meta.sectionId}`].pagination.items
              .concat(action.payload.result.items),
          },
        },
      };
    case `${t.FETCH_STORIES}_ERROR`:
      return {
        ...state,
        [`section-${action.meta.sectionId}`]: {
          ...state[`section-${action.meta.sectionId}`],
          status: STATUSES.ERROR,
        },
      };

    // fetch sections
    case `${t.FETCH_SECTIONS}_PENDING`:
      return {
        ...state,
        sections: {
          ...state.sections,
          status: STATUSES.PENDING,
          isLoaded: false,
        },
      };

    case `${t.FETCH_SECTIONS}_SUCCESS`: {
      const {
        type,
        hiddenSections,
      } = action.meta;

      const sections = action.payload.result;
      sections.splice(1, 0, ...(hiddenSections || []));
      const sectionStories = {};
      sections.forEach((section) => {
        sectionStories[`section-${section.id}`] = makePaginationState();
      });

      if (type === SECTION_TYPES.ORIGINAL || type === SECTION_TYPES.STANDARD) {
        sections.splice(0, 0, {
          id: 0,
          name: '추천',
        });
      }

      return {
        ...state,
        ...sectionStories,
        sections: {
          ...state.sections,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          list: sections,
        },
      };
    }
    case `${t.FETCH_SECTIONS}_ERROR`:
      return {
        ...state,
        sections: {
          ...state.sections,
          status: STATUSES.ERROR,
        },
      };

    case `${t.REFRESH_STORIES}_PENDING`:
      return {
        ...state,
        [`section-${action.meta.sectionId}`]: {
          ...state[`section-${action.meta.sectionId}`],
          isLoaded: false,
          status: STATUSES.PENDING,
        },
      };
    case `${t.REFRESH_STORIES}_SUCCESS`:
      return {
        ...state,
        [`section-${action.meta.sectionId}`]: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: action.payload.result,
        },
      };
    case `${t.REFRESH_STORIES}_ERROR`:
      return {
        ...state,
        [`section-${action.meta.sectionId}`]: {
          ...state[`section-${action.meta.sectionId}`],
          status: STATUSES.ERROR,
        },
      };

    // reset
    case t.RESET:
      return {
        ...state,
        [action.section]: makePaginationState(),
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/front/home/reducer.js